export enum UserSettingsKey {
  ConsumptionTileVisibility = "tileVisibility.Consumption",
  LargeConsumersTileVisibility = "tileVisibility.LargeConsumers",
  BurstTileVisibility = "tileVisibility.Burst",
  DryTileVisibility = "tileVisibility.Dry",
  LeakTileVisibility = "tileVisibility.Leak",
  ReverseTileVisibility = "tileVisibility.Reverse",
  TamperTileVisibility = "tileVisibility.Tamper",
  InactiveMeterTileVisibility = "tileVisibility.InactiveMeter",
  FrozenMeterTileVisibility = "tileVisibility.FrozenMeter",
  OverheatedMeterTileVisibility = "tileVisibility.OverheatedMeter",
  LeakAfterMeterTileVisibility = "tileVisibility.LeakAfterMeter",
  RecommendedLeakAfterMeterTileVisibility = "tileVisibility.RecommendedLeakAfterMeter",
  ZeroConsumptionTileVisibility = "tileVisibility.ZeroConsumption",
  MetersInWarningTileVisibility = "tileVisibility.MetersInWarning",
  MetersOfInterestTileVisibility = "tileVisibility.MetersOfInterest",
  ReadingPerformanceTileVisibility = "tileVisibility.ReadingPerformance",
  CollectorStatusTileVisibility = "tileVisibility.CollectorStatus",
  TilesDateDaysAgo = "tilesDate.DaysAgo"
}

export interface GetUserSettingsResponse {
  key: string;
  value: string;
}

export interface SetUserSettingsResponse {
  key: string;
  value: string;
}
